<!--
================================================
Un composant affichant l'abonnement en cours du workspace et permettatn d'ouvrir le Stripe customer portal

Url d'accès :
http://localhost:8080/fr/hotjar-inc/hotjar-workspace/subscription?cycle=month&pgr=fr-3ertuixp
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>

  <div class="formSection " id="WorkspaceSettingSubscription" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

    <div class="spacer">

      <div class="blocCurSub  px-0 py-0">


        <div class="content mb-0">

          <div class="planSummary">

            {{ $t('vousAvezActuellementUnAbonnement') }}
            <span class="planName"
                  v-bind:style="{color :activeStripeProduct.metadata.color}">{{ activeStripeProduct.name }}

              <span class="planName" v-bind:style="{color:activeStripeProduct.metadata.color}">
                   <span v-if="currentSubIsActivePremium()">
                    <font-awesome-icon
                    :content="$t('vousAvezAccèsAuxFonctionsPremium')"
                    v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', trigger: 'mouseenter'}"
                    class="icon premium ml-1" :icon="['fas', 'medal']"/>
                  </span>
              </span>
            </span>


          </div>

          <div class="details">

            <span class="seatDetails">{{ $tc('xUtilisateursSummary', activeStripeSubscription.quantity) }}</span>
            <span v-if="activeStripeSubscription.status!='trialing'" class="priceDetails">- {{
                $t('prixParCycle', {
                  'price': activePlanAmount,
                  'cycle': 'mois',
                  'currency': currencyToSign('EUR')
                })
              }}</span>
            <span class="statusDetails" >

              <!-- Abonnement trial-->
              <span v-if="activeStripeSubscription.status=='trialing'">

               <span class="statusTag trialing">
<!--                <font-awesome-icon :icon="['fas', 'check']" class="icon"/>-->
                 🎁 {{$t('EssaiGratuitJusquAu',{date:$moment.unix(this.activeStripeSubscription.trial_end).format('ll')})}}
               </span>
              </span>

              <!-- Abonnement actif-->
              <span v-if="activeStripeSubscription.status=='active' && !subIsCancelAtPeriodEnd() && !subIsPaused()">

               <span class="statusTag active">
                <font-awesome-icon :icon="['fas', 'check']" class="icon"/>
                 {{$t('actif')}}
               </span> |
                {{$t('valableJusquAu',{date:$moment.unix(this.activeStripeSubscription.current_period_end).format('ll')})}}
              </span>

              <!-- Abonnement en pause-->
              <span v-if="activeStripeSubscription.status=='active' && subIsPaused()">

               <span class="statusTag paused">
                 {{$t('suspendu')}}
               </span> |
                {{$t('repriseLe',{date:$moment.unix(this.activeStripeSubscription.pause_collection.resumes_at).format('ll')})}}
              </span>

              <!-- Abonnement annulation prévue-->
              <span v-else-if="subIsCancelAtPeriodEnd()">
               <span class="statusTag cancel">{{ $t('annulé') }}</span> |
                {{ $t('prendraFinLe', {date: $moment.unix(activeStripeSubscription.cancel_at).format('ll')}) }}
              </span>

              <!-- Abonnement annulé-->
              <span v-else-if="subIsCanceled()">
               <span class="statusTag cancel">{{ $t('annulé') }}</span> |
                {{ $t('depuisLe', {date: $moment.unix(activeStripeSubscription.canceled_at).format('ll')}) }}
              </span>


            </span>


          </div>
        </div>

        <div class="editZone" v-if="currentSubIsPremium()">

          <a class="button edit" v-on:click="getCustomerPortal()"  >

            <span>{{ $t('GérerLAbonnement') }}</span>
            <font-awesome-icon class="icon spinnerIcon " :icon="['fas', 'spinner']" spin  v-if="portalGenerating" />

          </a>


        </div>

      </div>


    </div>

  </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import SentryMixin from "../../mixins/SentryMixin.js";
import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "../../mixins/InterceptorMixin.js";
import CurrencyMixin from "@/mixins/CurrencyMixin";
import PlansBlocsSection from "@/components/pricing/plansBlocsSectionComp";

export default {
  name: 'WorkspaceSettingSubscriptionComp',
  components: {PlansBlocsSection},
  mixins: [SentryMixin, GlobalErrorNotification, InterceptorMixin, CurrencyMixin],
  // components: {},
  data: function () {
    return {
      isSubmiting: false,     // indique si le formulaire est en cours de soumission
      workspaceSlug: this.$auth.getActiveWorkspace(), //@todo dynamiser dans #290 https://gitlab.com/ousmane1/kronocloud/-/issues/290

      stripeCustomerPortal: {}, // L'objet Stripe customer portal de l'utilisateur (sert de variable à stripeCustomerPortalComput) //@todo besoin de tout l'objet ou garder juste url ?

      portalGenerating: false // Boolean indiquant si une requête de génération du stripe customer portal est en cours sur le backend
    }
  },
  props: {
    planName: {
      type: String, required: true, // le nom du plan
    },
    quantity: {
      type: Number, required: true, // le nombre de siège
    },


    activeStripeSubscription: {
      //@todo refactorer dans des simple avr
      // un object stripe subscription = la subscription actuelle du workspace
      type: Object,
      required: true
    },
    activeStripeProduct: {
      // un object stripe product = le plan actuel du workspace
      type: Object,
      required: true
    },
  },
  computed: {
    // https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
    // computed props for store :
    ...mapState({
      organizationSlug: state => state.organization.slug,
      userSlug: state => state.user.slug,
      themeToDisplay: state => state.app.themeToDisplay
    }),

    // le prix du plan de la subscription actuelle (reformaté car l'api stripe affiche les montants en centimes)
    activePlanAmount: {
      get: function () {
        return this.activeStripeSubscription.items.data[0].plan.amount / 100
      }
    },

    // la date de fin de la subscription actuelle
    activePlanEndDate: {
      get: function () {
        return this.$moment.unix(this.activeStripeSubscription.current_period_end).format('L')
      }
    },

    cancelPlanEndDate: {
      "cancel_at": 1637402010,
      "cancel_at_period_end": true,
      "canceled_at": 1634723698,
      get: function () {
        return this.$moment.unix(this.activeStripeSubscription.current_period_end).format('L')
      }
    },

    /**
     * Le stripe customer portal
     */
    stripeCustomerPortalComput: {
      get: function () {
        return this.stripeCustomerPortal
      },
      set: function (value) {
        this.stripeCustomerPortal = value
      }
    },


  },

  methods: {

    /**
     * Retourne true si la subscription est active ( si elle a la propriété 'status' définie à 'active' et metadata.isPremium à true)
     */
    currentSubIsActivePremium(){
      if(this.activeStripeSubscription.status=='active' && this.activeStripeProduct.metadata.isPremium==='true'){
        return true
      }
    },

    /**
     * Retourne true si la subscription est premium (même si plus active  et metadata.isPremium à true)
     */
    currentSubIsPremium(){
      if(this.activeStripeProduct.metadata.isPremium==='true'){
        return true
      }
    },

    /**
     * Retourne true si la subscription est active ( si elle a la propriété 'status' définie à 'active')
     */
    currentSubIsActive(){
      if(this.activeStripeSubscription.status=='active'){
        return true
      }
    },

    /**
     * Retourne true si la subscription en cours est active mais prévue sera annulé à la fin de la période
     */
    subIsCancelAtPeriodEnd(){
      if(this.activeStripeSubscription.cancel_at_period_end){
        return true
      }
    },

    /**
     * Retourne true si la subscription est annulée
     **/
    subIsCanceled(){
      if(this.activeStripeSubscription.status=='canceled'){
        return true
      }
    },

    /**
     * Retourne true si la subscription est en pause
     * @link https://stripe.com/docs/billing/subscriptions/pause
     * @link https://stripe.com/docs/billing/subscriptions/pause#unable-provide-services
     */
    subIsPaused(){
      if(this.activeStripeSubscription.pause_collection!= undefined && this.activeStripeSubscription.pause_collection.behavior==='void'){
        return true
      }
    },



    /*
          Effectue une requête pour récupérer le customer portal Stripe de l'user
          */
    getCustomerPortal() {
      this.portalGenerating=true
      let self = this;
      return self.$http

          .get(`/s/organizations/${self.organizationSlug}/workspaces/${self.workspaceSlug}/users/${self.userSlug}/customer/portal`, {
            headers: {Authorization: self.$auth.header()}
          })
          .then(function (response) {
            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

            self.stripeCustomerPortalComput = response.data // utile ? @todo mettre en cache ?
            // redirection vers le customer portal stripe
            window.location = response.data.url
            return {}
          })
          .catch(function (error) {
            let errorCode = '0060'
            let errorMsg = 'error on fetching stripe customer portal'
            self.showGlobalErrorNotif(self,errorCode)
            self.$gtag.exception({'description': 'error '+errorCode + ' | '+errorMsg, 'fatal': false})
            //
            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": errorMsg})
            self.$sentry.captureMessage(`Error ${errorCode} > ${errorMsg} : ${error}`, 'error')

          }).then(() => {
            // toujours exécuté
            self.portalGenerating = true;
          })
    }

  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)

  created: function () {
  },

  mounted: function () {


    // récupération de la devise actuelle
    this.isSubmiting
  },
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/globalVar";

#WorkspaceSettingSubscription {

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////
  .blocCurSub {
    background-color: white;
    box-shadow: 0 2px 5px #ccc;
    text-align: left;
    border: dashed 1px $lightBlue;

    .content {
      padding: 2rem;

    }

    h3 {
      //font-size: 1.2rem;
      color: #666;
      font-weight: bold;
      margin: 0 .5rem 2rem 0;

      .icon {
        color: #ccc;
        vertical-align: text-bottom;
      }
    }

    .planSummary {
      //color: #666;
      ::v-deep b {
        //color: $brandBlue !important;
      }

      font-size: 1rem;
      font-weight: bold;

      .icon.premium{
        color: #999; font-size: .9rem;
        vertical-align: top;
      }
      .planName{
        border-radius: 3px;
        padding: .1rem;
      }
    }

    .details {
      margin-top: .6rem;
      font-size: .9rem;
      color: #999;

      .priceDetails {
        font-weight: bold;
      }

      .statusDetails {
        margin-left: .5rem;
        padding: .2rem .4rem;
        font-size: .8rem;
        border-radius: .3rem;
        font-weight: bold;
        background-color: #f4f4f4;
        color: $brandFourth !important;

        .statusTag{
          .icon{vertical-align: middle}

          &.active{color: #85c10e}
          &.cancel,&.paused{color: #f69a1d}
          &.expired{color: #f34648}
        }
      }
    }

    .editZone {
      background-color:#e7f1f7;
      padding: .5rem 2rem;


      .button {
        transition: box-shadow .3s;
        padding: 1.2rem;
        font-size: .9rem;
        font-weight: bold;
        background-color: white !important;
        border-color: #b4c7cb !important;
        color:$brandThird !important;
        box-shadow: 0 0 2px #ccc;


        &:hover{
          box-shadow: 0 1px 4px #ccc;

        }
        &:active{
          border-color: $brandBlue !important;
          //box-shadow: 0 -1px 3px #ccc;
          color:$brandBlue !important;

        }

        .icon {
          color:$brandPremium;
          font-size: .6rem;
          margin-left: .4rem;
        }

        &.upgrade {
          border-color: #b4c7cb;
          border-width: 1px;
          border-style: solid;
          color: $brandThird;
          box-shadow: 0 0 1px #ccc;

          .icon {
            color: $brandPremium;
          }

          &:hover {
            box-shadow: 0 0 5px #ccc;
          }

          &:active {
            color: $brandBlue;
          }
        }

        &.edit {
          background-color: $brandPrimary;
          color: white;
          border-color: $brandPrimary;
        }

      }
    }
  }

  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    .blocCurSub {
      box-shadow: none;
      background-color: $darkBg2;
      color: #666;
      border: dashed 1px #888;

      h3 {
        color: $darkContrastTxt;

        .icon {
          color: #666
        }
      }

      .planSummary {
        ::v-deep b {
          //color: $darkContrastTxt !important;
        }

        color: $darkTxt;

        .planName{
          //color:$darkBg2 !important;
        }
      }

      .details {
        color: #999;

        .statusDetails {
          background-color: $darkBg;
          color: #eee !important;
        }
      }

      .editZone {
        background-color: darken($darkBg2,
            5%);
      }

      .button {
        background-color: $darkLightBlue !important;

        //background-color: $darkLightBlue !important;
        border-color: $darkLightBlue !important;

        box-shadow: none;
        color: $darkBg2 !important;

        &:hover{
          //transition: background-color .2s;
          box-shadow: none;
          background-color: darken($darkLightBlue,3%) !important;

        }
        &:active{
          //background-color: transparent !important;
          //border-color: $brandPrimary !important;
          color :white !important;
        }
        .icon{
          color:$darkBg2;
        }
      }
    }
  }
}
</style>
